import axios from "axios";

export const createRouter = async (
  token: string,
  root_space_id: string,
  environment_id: string,
  signal_quality: string,
  signal_strength_dbm: string
) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/automation/wifi`,
      {
        root_space_id,
        environment_id,
        signal_quality,
        signal_strength_dbm,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};
